export const pt = {
  stats: [
    { value: "6+", labelLine1: "anos construindo", labelLine2: "sistemas back-end" },
    { value: "MSc", labelLine1: "Ciência da Computação", labelLine2: "UFBA" },
    { value: "5", labelLine1: "empresas", labelLine2: "onde contribuí" },
  ],
};
